<script>
  export default {
    methods: {
      $can (permissionName) {
        return this.$store.state.permission.permissions.indexOf(permissionName) !== -1
      },
    },
  }
</script>
